import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Image } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
    HotTopicWrap,
    HotTopicDetail,
    HotTopicText,
} from "./postGridStyle";
import { blogListHandler } from "../../../redux/slices/blogs/blogList-slice";
import { useNavigate } from "react-router-dom";
import NoImage from "../../../assests/images/gnp_noimg.png"

const PostGrid = () => {
    const dispatch: any = useDispatch();
    const navigate: any = useNavigate();
    const blogList = useSelector((state: any) => state?.blogList?.data?.results?.slice(0, 10));

    useEffect(() => {
        dispatch(blogListHandler("", "", "", ""));
    }, [])
    return (
        <HotTopicWrap className="hot-topic-wrap">
            <HotTopicDetail>
                {blogList?.slice(0, 3)?.map((hotTopic: any, index: number) => (
                    <div key={index + 1}>
                        {/* <Image src={hotTopic?.large_image || NoImage} alt="Palomacy Pigeon" /> */}
                        <Image src={NoImage} alt="Palomacy Pigeon" />
                        <HotTopicText
                            onClick={() => window.open(`${import.meta.env.VITE_BLOG_URL}${hotTopic?.slug}`, '_blank')}
                        >
                            {hotTopic?.title}
                        </HotTopicText>

                    </div>))}
            </HotTopicDetail>
        </HotTopicWrap>
    )
};
export default PostGrid;